import { DECISION_TRACKS, DecisionTrack } from "@/constants/decision-track";
import { DivergenceStatusEnum } from "@/enum/divergence-status";

import { trackOf } from "./decision-track";
import { DECISION_LABELS } from "./messages";
import { PayrollDiscountCandidate } from "./is-payroll-discount";

export type DecisionStatus =
  | DivergenceStatusEnum.APPROVED
  | DivergenceStatusEnum.REJECTED;

const APPROVAL_CONSEQUENCES: Record<DecisionTrack, string> = {
  [DECISION_TRACKS.PAYROLL_DISCOUNT]:
    DECISION_LABELS.CONSEQUENCE_PAYROLL_DISCOUNT,
  [DECISION_TRACKS.ACCOUNTED_LOSS]: DECISION_LABELS.CONSEQUENCE_ACCOUNTED_LOSS,
  [DECISION_TRACKS.LOSS_WITHDRAWN]: DECISION_LABELS.CONSEQUENCE_LOSS_WITHDRAWN,
};

export const consequenceOf = (
  action: DecisionStatus,
  divergence: PayrollDiscountCandidate
): string => {
  if (action === DivergenceStatusEnum.REJECTED) {
    return DECISION_LABELS.CONSEQUENCE_REJECT;
  }

  return APPROVAL_CONSEQUENCES[trackOf(divergence)];
};
